import React from "react";
import { FontawesomeComponent } from "../../../components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MyBooking from '../Modals/MyBooking'

export const MenuData = [
  {
    title: "Giới thiệu",
    path: "#",
    icon: "/images/intro.png",
    cName: "item_menu col-lg-3 col-12 col-md-6",
    iconClosed: <FontawesomeComponent icon="angle-down" />,
    iconOpened: <FontawesomeComponent icon="angle-up" />,
    status: "active",
    subMenu: [
      {
        title: "Về Mandala Hotel",
        path: "/about-us/ve-mandala",
      },
      {
        title: "Mục tiêu phát triển",
        path: "/about-us/muc-tieu-phat-trien",
      },
      {
        title: "Tin tức",
        path: "/about-us/tin-tuc",
      },
      {
        title: "Tuyển dụng",
        path: "/about-us/tuyen-dung",
      },
    ],
  },
  {
    title: "Điểm đến",
    path: "/destination",
    icon: "/images/loc.png",
    cName: "item_menu col-lg-3  col-12 col-md-6",
    status: "active",
  },
  {
    title: "Ưu đãi",
    path: "/endow",
    icon: "/images/UD.png",
    cName: "item_menu col-lg-3 col-12 col-md-6",
    status: "active",
  },
  {
    title: "Đánh giá",
    path: "/feedback",
    icon: "/images/comment.png",
    cName: "item_menu col-lg-3 col-12 col-md-6",
    status: "active",
  },
  {
    title: "Trải nghiệm",
    path: "/experiences",
    icon: "/images/TN.png",
    cName: "item_menu col-lg-3 col-12 col-md-6",
    status: "active",
  },
  {
    title: "Khách sạn",
    path: "/hotel",
    icon: "/images/logoMenu.png",
    cName: "item_menu col-lg-3 col-12 col-md-6",
    status: "active",
  },
  {
    title: "Thư viện",
    path: "/media",
    icon: "/images/lib.png",
    cName: "item_menu col-lg-3 col-12 col-md-6",
    status: "active",
  },
  {
    title: "Ngôn ngữ",
    path: "#",
    icon: "/images/ic_language.png",
    cName: "item_menu col-lg-3 col-12 col-md-6",
    iconClosed: <FontawesomeComponent icon="angle-down" />,
    iconOpened: <FontawesomeComponent icon="angle-up" />,
    status: "mobile",
    subMenu: [
      {
        title: "VN",
        path: "",
      },
      {
        title: "ENG",
        path: "",
      },
    ],
  },
  {
    title: <MyBooking />,
    path: "#",
    icon: "/images/ic_booking_room.png",
    cName: "item_menu col-lg-3 col-12 col-md-6",
    status: "mobile",
  },
  {
    title: "0222 386 88 66",
    path: "tel:02223868866",
    icon: "/images/ic_phone_call.png",
    cName: "item_menu col-lg-3 col-12 col-md-6",
    status: "mobile",
  },
];
